var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', {
    staticClass: "main-section--sm"
  }, [_c('swiper', {
    staticClass: "swiper",
    attrs: {
      "options": _vm.options
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      staticClass: "product-image",
      attrs: {
        "src": item.image,
        "alt": item.name
      }
    }), _c('div', {
      staticClass: "logo-wrap"
    }, [_c('img', {
      attrs: {
        "src": item.logo,
        "alt": item.company
      }
    })])]);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }